import template from './CircleNumberView.hbs';
import { BaseView, Prototype } from '../BaseView';


@Prototype({
    template,
    className: 'icon-circle icon-circle--red-white icon-circle--xs hidden'
})
export class CircleNumberView extends BaseView {

    initialize(options) {

        this.options = options;
    }

    serializeData() {

        return {
            num: this.options.num
        }
    }

    onRender() {

        const {
            isZeroVisible,
            num,
        } = this.options;

        const isHidden = !(isZeroVisible || num);

        this.$el.toggleClass('hidden', isHidden);
    }
}


// WEBPACK FOOTER //
// ./shared/view/CircleNumberView/CircleNumberView.js